import { ca } from '@cian/analytics';

export const trackRetryClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Click',
    label: 'BrokerDealPopUpRetry',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
    },
    useLastProducts: true,
  });
};
